import { FC } from "react";
import Text from "../../Text";
import { useDailyGiftContext } from "./context";

const DailyGiftDays: FC = (props) => {
    const gift = useDailyGiftContext();

    if (gift?.days === undefined) {
        return null;
    }

    return (
        <Text text={gift.days} {...props} />
    )
}

export default DailyGiftDays;
